import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState, PayloadMap } from '@src/core/store';

export const checkoutSteps = [
  {
    order: 1,
    name: 'login',
  },
  {
    order: 1,
    name: 'signup',
  },
  {
    order: 2,
    name: 'personal',
  },
  {
    order: 3,
    name: 'payment',
  },
] as const;

const checkoutStepsOnlyNames = checkoutSteps.map((step) => step.name)[0]!;

export const CheckoutErrors = ['foreignCustomerNotAllowed'];
export type CheckoutStepType = typeof checkoutStepsOnlyNames;

export interface CheckoutState {
  step: { [key: string]: CheckoutStepType | '' };
  errors?: string[];
}

const initialState: CheckoutState = {
  step: {},
};

export const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    setStepCheckout(state: CheckoutState, action: PayloadAction<PayloadMap<CheckoutStepType | ''>>) {
      state.step[action.payload.id] = action.payload.value;
    },
    setErrors(state: CheckoutState, action: PayloadAction<string[]>) {
      state.errors = action.payload;
    },
  },
});

export default checkoutSlice.reducer;

export const { setStepCheckout, setErrors } = checkoutSlice.actions;

export const checkoutStepState = (id: string) => (state: RootState) => {
  const steps = [...new Set(checkoutSteps.map((item) => item.order))];
  const stepCheckout = stepCheckoutSelector(id)(state);
  const currentStep = checkoutSteps.find((s) => s.name === stepCheckout);

  return { steps, currentStep };
};

export const stepCheckoutSelector = (id: string) => (state: RootState) => state.checkout.step[id];
export const checkoutErrorsSelector = (state: RootState) => state.checkout.errors;
